<template>
  <div>
    <main-layout>
      <v-container>
        <h1>{{ $t('whatsapp_template_management') }}</h1>
        <div>
          <template-list />
        </div>
      </v-container>
    </main-layout>
  </div>
</template>

<script>
import TemplateList from './TemplateList.vue'

export default {
  components: {
    TemplateList
  },

  mounted() {
    this.$store.dispatch('loadSetting')
    this.$store.dispatch('loadCategory')
    this.$store.dispatch('loadProducts')
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/whatsapp/TemplateManagement/index.vue